import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useService } from "../../container";

interface QueryProviderProps {
    children: React.ReactNode;
}

function QueryProvider(props: QueryProviderProps) {
    // * Props
    const { children } = props;

    const client = useService("queryClient");

    // * Render
    return (
        <QueryClientProvider client={client}>
            {children}
            <ReactQueryDevtools />
        </QueryClientProvider>
    );
}

export default QueryProvider;
